export default __webpack_public_path__ + "static/media/Overpass-Regular.4be3ad84.ttf";